/**
 * Roles de OFICINA: con uno de estos, al entrar se aterriza en el panel.
 *
 * Es una lista aparte de `PANEL_ROLES` desde el 25-set. Antes era la misma, y agregarle `supervisor`
 * para que entrara al panel lo habría sacado de «Mi turno» y «Mi ruta» al iniciar sesión, que es su
 * trabajo de todos los días en el celular.
 */
export const ROLES_DE_OFICINA = ['admin', 'comercial', 'coordinador', 'datos', 'direccion'];

/**
 * Roles que PUEDEN entrar al panel: el guarda de `/panel` y el botón «Ir al panel» del celular.
 * El supervisor entra a ver sus tiendas (solo lectura, 0218), pero no aterriza acá.
 */
export const PANEL_ROLES = [...ROLES_DE_OFICINA, 'supervisor'];

/**
 * La app de compras, «Cotizaciones Treid» (spec 2026-10-06-compras-design.md §2.1 y §2.3): la ruta visible dice
 * cotizaciones y el nombre interno sigue siendo compras. Es OTRA entrada de Vite: se llega con recarga completa.
 */
export const RUTA_COMPRAS = '/cotizaciones/';

export function esRutaDeCompras(ruta: string): boolean {
  return ruta.startsWith(RUTA_COMPRAS);
}

/**
 * Ruta de inicio (spec §3.3, fila 6), en este orden: con un rol de oficina, el panel; si es comprador, Cotizaciones
 * Treid; si es de campo (recurso o supervisor), el celular, como hoy (un solicitante de campo sigue aterrizando en su
 * turno y entra a sus solicitudes por el enlace directo); si solo es solicitante, Cotizaciones Treid. El comprador con
 * un rol de oficina aterriza en el panel y llega por el enlace del menú.
 */
export function homeRoute(roles: string[]): string {
  // Dirección (0396) entra al resumen gerencial, salvo que además tenga un rol de trabajo de oficina.
  if (roles.includes('direccion') && !roles.some((r) => ['admin', 'comercial', 'coordinador', 'datos'].includes(r))) {
    return '/panel/resumen';
  }
  if (roles.some((r) => ROLES_DE_OFICINA.includes(r))) return '/panel/hoy';
  if (roles.includes('comprador')) return RUTA_COMPRAS;
  if (roles.includes('recurso') || roles.includes('supervisor')) return '/movil';
  if (roles.includes('solicitante')) return RUTA_COMPRAS;
  return '/movil';
}

/**
 * Adónde ir después del login. `?volver=` se respeta SOLO si es una ruta de Cotizaciones Treid: así el enlace que
 * llega por WhatsApp (`/cotizaciones/#aprobar=<id>` o `#solicitud=<id>`) sobrevive al login de Roberto o Juan Pablo,
 * que son admin y si no irían a /panel/hoy. Cualquier otro valor se ignora, para que el parámetro no sirva de redirección abierta.
 */
export function destinoTrasLogin(roles: string[], search: string): string {
  const volver = new URLSearchParams(search).get('volver');
  if (volver && /^\/cotizaciones\/[A-Za-z0-9_/-]*$/.test(volver) && !volver.includes('//')) return volver;
  return homeRoute(roles);
}

/** Navega: a compras con recarga completa (el comodín del router la devolvería a `/`), al resto con el router. */
export function irAlDestino(
  destino: string,
  navigate: (to: string, opts?: { replace?: boolean }) => void,
  reemplazar = true,
): void {
  if (esRutaDeCompras(destino)) {
    window.location.assign(destino);
    return;
  }
  navigate(destino, { replace: reemplazar });
}
